export enum EIntegration {
    GMetrix = 6,
    Jasperactive = 2,
    XED = 35,
    Bulb = 41
}